import { ScreenDefinition } from 'src/ui/common/screens/ScreenDefinition';
import { WF_Screen } from './WfScreens';
import WfUnderConstruction from '../common/underConstruction/WfUnderConstruction';
import WfLogin from '../common/login/WfLogin';
import WF_4_3_2_MainMenu from '../mobile/mainMenu/WF_4_3_2_MainMenu';
import WF_4_4_1_PropertiesList from '../desktop/propertyList/WF_4_4_1_PropertiesList';
import WF_4_4_2_PropertiesList from '../mobile/propertiesList/WF_4_4_2_PropertiesList';
import WF_4_5_2_PropertiesMap from '../mobile/map/WF_4_5_2_PropertiesMap';
import WF_4_5_1_PropertiesMap from '../desktop/map/WF_4_5_1_PropertiesMap';
import WF_4_6_1_PropertyStatusDetailsRegistration from '../common/propertyStatusDetailsRegistration/WF_4_6_1_PropertyStatusDetailsRegistration';
import WF_4_7_2_AlertHistory from '../mobile/alertHistory/WF_4_7_2_AlertHistory';
import WF_4_8_1_DataSummary from '../desktop/dataSummary/WF_4_8_1_DataSummary';
import WF_4_11_1_SystemLaunch from '../desktop/systemLaunch/WF_4_11_1_SystemLaunch';
import WF_Main from '../desktop/WF_Main';
import WF_4_7_4_AlertHistoryDetails from '../mobile/alertHistory/WF_4_7_4_AlertHistoryDetails';
import WF_4_7_1_AlertHistory from '../desktop/alertHistory/WF_4_7_1_AlertHistory';
import WF_UserSearch from '../desktop/userSearch/WF_UserSearch';
import WF_4_10_2_ProductListWideArea from '../mobile/productList/WF_4_10_2_ProductListWideArea';
import { BranchSummary } from '../desktop/summary/branchSummary/BranchSummary';
import { BusinessSummary } from '../desktop/summary/businessSummary/BusinessSummary';
import P7_1_SiteDetails from '../desktop/siteDetails/P7_1_SiteDetails';
import WF_4_9_2_ProductList from '../mobile/productList/WF_4_9_2_ProductList';

export const WfScreensMap: Record<WF_Screen, ScreenDefinition> = {
  [WF_Screen.UnderConstruction]: {
    key: WF_Screen.UnderConstruction,
    path: 'under-construction',
    mobileComponent: <WfUnderConstruction />,
  },
  [WF_Screen.Login]: {
    key: WF_Screen.Login,
    path: 'login',
    mobileComponent: <WfLogin />,
    desktopComponent: <WfLogin />,
  },
  [WF_Screen.MainMenu]: {
    key: WF_Screen.MainMenu,
    path: 'mainMenu',
    mobileComponent: <WF_4_3_2_MainMenu />,
    desktopComponent: <WF_Main component={<WF_4_5_1_PropertiesMap />} />,
  },
  [WF_Screen.PropertiesList]: {
    key: WF_Screen.PropertiesList,
    path: 'propertiesList',
    mobileComponent: <WF_4_4_2_PropertiesList />,
    desktopComponent: <WF_Main component={<WF_4_4_1_PropertiesList />} />,
  },
  [WF_Screen.PropertiesMap]: {
    key: WF_Screen.PropertiesMap,
    path: 'propertiesMap',
    mobileComponent: <WF_4_5_2_PropertiesMap />,
    desktopComponent: <WF_Main component={<WF_4_5_1_PropertiesMap />} />,
  },
  [WF_Screen.PropertyStatusRegistration]: {
    key: WF_Screen.PropertyStatusRegistration,
    path: 'propertyStatusRegistration',
    mobileComponent: <WF_4_6_1_PropertyStatusDetailsRegistration />,
    desktopComponent: <WF_Main component={<WF_4_6_1_PropertyStatusDetailsRegistration />} />,
  },
  [WF_Screen.AlertHistory]: {
    key: WF_Screen.AlertHistory,
    path: 'alertHistory',
    mobileComponent: <WF_4_7_2_AlertHistory />,
    desktopComponent: <WF_Main component={<WF_4_7_1_AlertHistory />} />,
  },
  [WF_Screen.AlertHistoryDetails]: {
    key: WF_Screen.AlertHistoryDetails,
    path: 'alertHistoryDetails',
    mobileComponent: <WF_4_7_4_AlertHistoryDetails />,
    desktopComponent: <WF_Main component={<WF_4_7_1_AlertHistory />} />,
  },
  [WF_Screen.BranchSummary]: {
    key: WF_Screen.BranchSummary,
    path: 'branchSummary',
    desktopComponent: <WF_Main component={<BranchSummary />} />,
  },
  [WF_Screen.BusinessSummary]: {
    key: WF_Screen.BusinessSummary,
    path: 'businessSummary',
    desktopComponent: <WF_Main component={<BusinessSummary />} />,
  },
  [WF_Screen.DataSummary]: {
    key: WF_Screen.DataSummary,
    path: 'dataSummary',
    mobileComponent: <WF_4_8_1_DataSummary />,
    desktopComponent: <WF_Main component={<WF_4_8_1_DataSummary />} />,
  },
  [WF_Screen.SystemLaunch]: {
    key: WF_Screen.SystemLaunch,
    path: 'systemLaunch',
    mobileComponent: undefined,
    desktopComponent: <WF_Main component={<WF_4_11_1_SystemLaunch />} isSystemLaunch />,
  },
  [WF_Screen.UserSearch]: {
    key: WF_Screen.UserSearch,
    path: 'userSearch',
    mobileComponent: undefined,
    desktopComponent: <WF_Main component={<WF_UserSearch />} />,
  },
  [WF_Screen.ProductList]: {
    key: WF_Screen.ProductList,
    path: 'productList',
    mobileComponent: <WF_4_9_2_ProductList />,
    desktopComponent: undefined,
  },
  [WF_Screen.ProductListWideArea]: {
    key: WF_Screen.ProductListWideArea,
    path: 'productListWideArea',
    mobileComponent: <WF_4_10_2_ProductListWideArea />,
    desktopComponent: undefined,
  },
  [WF_Screen.WorkplaceDetails]: {
    key: WF_Screen.WorkplaceDetails,
    path: 'workplaceDetail',
    mobileComponent: <P7_1_SiteDetails />,
    desktopComponent: <WF_Main component={<P7_1_SiteDetails />} />,
  },
  [WF_Screen.ListSearch]: {
    key: WF_Screen.ListSearch,
    path: 'listSearch',
    mobileComponent: <WF_4_4_2_PropertiesList />,
    desktopComponent: <WF_4_4_1_PropertiesList />,
  },
};
